export default __webpack_public_path__ + "static/media/StarEmpty.145ae605.svg";